/**
 * US-13: Client helpers for Stripe Checkout + Customer Portal.
 */
import { auth } from '../firebase';
import { getApiEndpoint } from './apiBaseUrl';

async function getBearerToken() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Authentication required. Please sign in again.');
  }
  return user.getIdToken();
}

/**
 * @returns {Promise<string>} Stripe Checkout redirect URL
 */
export async function createCheckoutSession() {
  const token = await getBearerToken();
  const response = await fetch(getApiEndpoint('create-checkout-session'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.error || 'Could not start checkout.');
    if (data.code) err.code = data.code;
    throw err;
  }
  if (!data.url) {
    throw new Error('Checkout did not return a redirect URL.');
  }
  return data.url;
}

/**
 * @returns {Promise<string>} Stripe Customer Portal URL
 */
export async function createBillingPortalSession() {
  const token = await getBearerToken();
  const response = await fetch(getApiEndpoint('create-billing-portal-session'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.error || 'Could not open billing portal.');
    if (data.code) err.code = data.code;
    throw err;
  }
  if (!data.url) {
    throw new Error('Billing portal did not return a redirect URL.');
  }
  return data.url;
}
